import { render, staticRenderFns } from "./AnnotationsCanvas.vue?vue&type=template&id=59787396&"
import script from "./AnnotationsCanvas.vue?vue&type=script&lang=js&"
export * from "./AnnotationsCanvas.vue?vue&type=script&lang=js&"
import style0 from "./AnnotationsCanvas.vue?vue&type=style&index=0&id=59787396&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports